import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { Profile } from './components';
import { AMODULO_FINANCAS } from 'consts';
import { makeStyles } from '@material-ui/styles';
import SidebarNav from './components/SidebarNav';
import { Divider, Drawer } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: { margin: theme.spacing(2, 0) },
  nav: { marginBottom: theme.spacing(2) }
}));

const SideBarFinancas = (props) => {
  const {
    className,
    onClose,
    open,
    variant,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(
          classes.root,
          className
        )}
      >
        <Profile />

        <Divider
          className={classes.divider}
        />

        <SidebarNav
          className={classes.nav}
          moduleCode={AMODULO_FINANCAS}
          showBackToFront
        />
      </div>
    </Drawer>
  );
};

SideBarFinancas.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default SideBarFinancas;